import { IPagedListResponse } from "domain/types/global/pagedListResponse"
import { USUARIOS_EMPRESA_GET, UsuarioActionTypes, UsuarioState } from "domain/types/usuario/usuario"
import { UsuarioResponse } from "domain/types/usuario/usuarioResponse"
import { DispatchReset, PagedReducer, PagedReducerReset } from "../../../utils/reducerUtil"

const INITIAL_STATE: UsuarioState = {
    UsuariosEmpresa: undefined,
}

export function UsuarioReducer(state = INITIAL_STATE, action: UsuarioActionTypes): UsuarioState {
    switch (action.type) {
        case USUARIOS_EMPRESA_GET:
            //return {...state, UsuariosEmpresa:action.payload}
            return PagedReducer(state, "UsuariosEmpresa", action.payload, "UsuarioID", USUARIOS_EMPRESA_GET )
            
        case DispatchReset(USUARIOS_EMPRESA_GET):
            return PagedReducerReset(state, "UsuariosEmpresa", {} as IPagedListResponse<UsuarioResponse>, "CampanhaPedidoResgateID", USUARIOS_EMPRESA_GET)
            
        default:
            return state
    }
}